import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./CourseOverviewListSection.module.scss";
import {CourseOverviewListItem} from "./courseOverviewListItem/CourseOverviewListItem";

export interface ICourseOverviewListSectionProps {
  title: string,
  items: string[],
}

export const CourseOverviewListSection: VoidFunctionComponent<ICourseOverviewListSectionProps> = ({title, items}) => {
  // Using the index as the key because the list item count and order doesn't change
  // https://www.developerway.com/posts/react-key-attribute
  const listItems = items.map((item, index) => (<CourseOverviewListItem content={item} key={index} />));

  return (
    <div className={s.courseOverviewListSection}>
      <h3>{title}</h3>
      <ul className={s.sectionList}>
        {listItems}
      </ul>
    </div>
  );
}

